import { GenericDialog } from "./GenericDialog";

export type InformationDialogProps = {
  caption: string;
  message: string;
};

export function InformationDialog(props: InformationDialogProps) {
  return (
    <GenericDialog buttons="OK" {...props}>
      {props.message}
    </GenericDialog>
  );
}
